export default {
  headerContent: {
    title: 'Mapfre Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Mapfre Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Ferdi kaza sigortası, çok sayıda talihsiz olayı kapsar. Kazalar her an ve herkesin başına gelebilir! Çoğu zaman, bu tür aksilikler bir dizi istenmeyen masrafı beraberinde getirir. Ferdi kaza sigortası kapsamında bu durumlara karşı geniş önlemler sunulur. ',
        'Bir kaza, ailenizin finansal güvenliği üzerinde dalgalanma etkisi yaratabilir.',
        '<strong>Mapfre Sigorta ferdi kaza sigortası</strong> kaza sonucunda oluşacak çoğu hasar durumuna karşı güvence verilir ve bu güvenceler ile sigortalının kendisi ya da yakınlarına tazminat ödemesi yapılır. Neredeyse her türlü risk durumuna karşı verilen teminatlar ile sigortalı kişinin çoğu durumu için özel önlemler alınmaktadır.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası, kaza olarak nitelendirilecek çoğu durum için geçerlidir. Kas incinmeleri, trafik, iş ya da ev kazaları, hayvan ısırmaları, zehirlenmeler gibi kaza durumları sigorta kapsamı içindedir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
